<template>

  <div class="">
    <b-collapse id="filters" class="p-2">
      <div class="row">
        <div class="col-lg-4">
          <Search/>
        </div>
        <div class="col-lg-4">
          <tag-filter1 @updateFilter="setTagsFilter"/>
        </div>
        <div class="col-lg-4">
          <panel-filter @updateFilter="setPanelsFilter"/>
        </div>
      </div>
    </b-collapse>
    <b-table v-bind="tableAttributes" :fields="fields" :items="items">
      <template #cell(name)="data">
        {{ data.item.name }}
      </template>

      <template #cell(last_name)="data">
        {{ data.item.last_name }}
      </template>

      <template #cell(email)="data">
        <span class="text-wrap">{{ data.item.email }}</span>
      </template>

      <template #cell(tags)="data">
        <span class="text-wrap badge badge-success mx-1" v-for="tag in data.item.tags">{{ tag.name }}</span>
      </template>

      <template #cell(role)="data">
        {{ roleFa(data.item) }}
      </template>

      <template #cell(panels)="data">
        <span class="mx-1 badge badge-primary rounded-pill" v-for="panel in data.item.panels">{{
            panel.language.name
          }}</span>
      </template>

      <template #cell(created_at)="data">
        {{ convertToJalali(data.item.created_at) }}
      </template>

      <template #cell(action)="data">
        <div v-if="(data.item.deleted_at == null)">
                <span
                    class="h5"
                    v-if="isDeletable(data.item)"
                    @click="deleteFunction(data.item)"
                    v-b-tooltip.hover
                    title="حذف">
                    <b-icon icon="trash" class="m-2"></b-icon>
                </span>

          <span class="h5" v-b-tooltip.hover title="ویرایش">
                    <router-link target="_blank"
                                 :to="{ name: 'UpdateUser', params: { id: data.item.id } }">
                        <b-icon icon="pencil" class="m-2"></b-icon>
                    </router-link>
                </span>

          <span class="h5" v-b-tooltip.hover title="تغییر رمز">
                    <router-link target="_blank"
                                 :to="{ name: 'UpdateUserPassword', params: { id: data.item.id } }">
                        <b-icon icon="key" class="m-2"></b-icon>
                    </router-link>
                </span>


          <span class="h5" v-b-tooltip.hover title="آدرس های کاربر">
                    <router-link target="_blank"
                                 :to="{ name: 'UserAddresses', params: { id: data.item.id } }">
                        <b-icon icon="map" class="m-2"></b-icon>
                    </router-link>
                </span>

          <span class="h5" v-b-tooltip.hover title="کیف پول">
                    <router-link target="_blank"
                                 :to="{ name: 'ChargeWallet', params: { user: data.item.id } }">
                        <b-icon icon="wallet" class="m-2"></b-icon>
                    </router-link>
                </span>

          <span class="h5" v-b-tooltip.hover title="چت های کابر">
                    <router-link target="_blank"
                                 :to="{ name: 'UserChats', query: { user: data.item.id } }">
                        <b-icon icon="messenger" class="m-2"></b-icon>
                    </router-link>
                </span>

          <span class="h5" v-b-tooltip.hover title="موردعلاقه های کاربر">
                    <router-link target="_blank"
                                 :to="{ name: 'WishListUser', params: { user: data.item.id } }">
                        <b-icon icon="heart-fill" class="m-2"></b-icon>
                    </router-link>
                </span>


          <span class="h5">
                    <router-link target="_blank"
                                 :to="{ name: 'Subscription', params: { user: data.item.id } }">
                        <b-icon icon="cloud-check-fill" class="m-2"></b-icon>
                    </router-link>
                </span>

          <span class="h5" v-b-tooltip.hover title="فرم های پر شده کاربر">
                    <router-link target="_blank"
                                 :to="{ name: 'UserFormFills', params: { user: data.item.id } }">
                        <b-icon icon="archive-fill" class="m-2"></b-icon>
                    </router-link>
                </span>

          <span class="h5" @click="openUserProfileInSite(data.item)" v-b-tooltip.hover title="پروفایل کاربر در سایت">
                        <b-icon icon="person-circle" class="m-2"></b-icon>
                </span>

        </div>

        <div v-else>
                <span
                    class="h5"
                    v-b-tooltip.hover title="حذف دائمی"
                    v-if="isDeletable(data.item)">
                    <b-icon icon="trash" @click="forceDeleteFunction(data.item)"></b-icon>
                </span>

          <span class="h5" v-b-tooltip.hover title="بازگردانی">
                    <b-icon
                        icon="arrow-clockwise"
                        class="mr-3"
                        @click="restoreFunction(data.item)">
                    </b-icon>
                </span>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {convertToJalali} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import Search from './Search'
import {rolesTranslate} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/User";
import TagFilter1 from "@/plugin/components/dashboard/Filters/Tag/TagFilter1.vue";
import PanelFilter from "@/plugin/components/dashboard/Filters/Panel/PanelFilter.vue";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export default {
  name: 'UserItems',
  props: ['items'],
  components: {PanelFilter, TagFilter1, Search},
  data() {
    return {
      rolesTranslate,
      tableAttributes: {...tableAttributes, ...{responsive: 'xl'}},
      fields: [
        {key: "name", label: "نام"},
        {key: "last_name", label: "نام خانوادگی"},
        {key: "role", label: "نقش"},
        {key: "panels", label: "پنل"},
        {key: "email", label: "ایمیل"},
        {key: "cellphone", label: "تلفن همراه"},
        {key: "tags", label: "تگ"},
        {key: "created_at", label: "تاریخ عضویت"},
        {key: "action", label: "عملیات"},
      ],
    }
  },
  methods: {
    convertToJalali,
    ...mapActions({
      deletePerson: "User/deletePerson",
      forceDeletePerson: "User/forceDeletePerson",
      restorePerson: "User/restorePerson",
    }),
    deleteFunction(item) {
      if (confirm('آیا از حذف این کاربر اطمینان دارید؟')) {
        this.deletePerson(item);
      }
    },
    forceDeleteFunction(item) {
      const message = `
      حذف کاربر باعث حذف موارد ساخته شده توسط کاربر میشود.
      آمار کاربر:
      پست/برگه/درس: ${item.contents_count}
      دوره: ${item.courses_count}
      سفارش ها: ${item.orders_count}
      پیام: ${item.tickets_count}
      `

      if (confirm(message)) {
        this.forceDeletePerson(item);
      }
    },
    restoreFunction(item) {
      if (confirm('آیا از بازیابی این کاربر اطمینان دارید؟')) {
        this.restorePerson(item);
      }
    },
    isDeletable(item) {
      return (item.role == 0);
    },
    roleFa(user) {

      const userRole = `${user.role}-${user.type}`;

      return this.rolesTranslate[userRole]

    },
    setTagsFilter(data) {
      this.$store.commit("User/setFilters", {key: "tag", value: data.tags});
      this.$store.dispatch('User/getPersons', 1)
    },
    setPanelsFilter(data) {
      let panels = data.panels
      if (panels.length > 0) {
        this.$store.commit("User/setFilters", {key: "language", value: data.panels[0]});
      } else {
        this.$store.commit("User/setFilters", {key: "language", value: ''});
      }
      this.$store.dispatch('User/getPersons', 1)
    },
    openUserProfileInSite(user){
      let routeData = this.$router.resolve({name: 'UpdateUser', params: {id: user.id}});
      let link = findAttributeOnSiteInfo('site_link')[0]+routeData.href
       window.open(link, '_blank');
    }
  }
}
</script>

<style scoped>
.text-wrap {
  word-wrap: break-word;
}
</style>